module.exports = __webpack_public_path__ + "components/weather-icon/static/nightmodsnow-fc68591d7478d75f8968cf6b6bfb9a2c.svg";